/**
 * videoタグの動画再生スクリプト
 *
 */

function playVideos(videos) {
    const startPosition = $(window).scrollTop() + $(window).height();
    videos.each(function(index) {
        if(startPosition > $(this).offset().top && !$(this).attr('video-status')) {
            $(this).get(0).play();
 			$(this).attr('video-status', 'playd');
        }
    });
}


$(window).on('load', function() {
	const videos = $('.c-video__short');
	if(videos.length) {
		playVideos(videos);
		$(window).on('scroll', function() {
			playVideos(videos);
		});
		
		$('.c-video__short').mouseover(function(e){
			$(this).get(0).play();
		})
	}
});
